// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u01wug{margin-left:auto}\n._19pkidpf{margin-top:0}\n._1ltvidpf{left:0}\n._1pby16oo{z-index:510}\n._1xi2idpf{right:0}\n._2hwx1wug{margin-right:auto}\n._94n5xy5q{bottom:var(--ds-space-400,2pc)}\n._kqsw1n9t{position:fixed}\n._otyridpf{margin-bottom:0}\n._t9ec14jq{transform:translate3d(50%,0,0) perspective(1px)}\n._t9ecdgi6{transform:translate3d(0,100%,0) perspective(1px)}", ""]);
// Exports
module.exports = exports;
